
import { OperatorConfigLogEntry } from '@/api/dtos/LogEntry.schema'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class OperatorConfigLogEntryContent extends Vue {
  @Prop()
  logEntry!: OperatorConfigLogEntry
}
